import { PropsWithChildren, FC } from 'react'
import Card from '@/pages/Tbqy/components/components/Card'
import Top from './Top'
import Ydtj from './Ydtj'
import Gbmndtj from './Gbmndtj'

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {

  return (
    <Card title="委托单数据统计" hasExport={false}>
      <Top updateTime={updateTime} />
      <div className='mt-30 border-top pt-24 mlr-10'>
        <div className='' style={{height: '300px'}}>
          <Ydtj updateTime={updateTime} />
        </div>
        <div className='border-top pt-20 mt-10' style={{height: '300px'}}>
          <Gbmndtj updateTime={updateTime} />
        </div>
      </div>
    </Card>
  )
}

export default Component
